import encodeChars from './encodeChars';

export default {
  encode(data, {name}) {
    const key = encodeChars.colon(name);
    const val = data.value === '1' || data.value[1] ? 'Y' : 'N';

    return [key, val];
  },
  decode(value, filter) {
    if (filter.yes_no_1_0) {
      return {
        type: filter.settings.type,
        value: value === 'Y' ? '1' : '0',
      };
    }

    const newVal = {};
    const testVal = value === 'Y' ? 1 : 0;
    newVal[testVal] = filter.settings.label.find(label => label.value === testVal)?.title || '';

    return {
      type: filter.settings.type,
      value: newVal,
    };
  },
};
